import Table, { type Column as TableColumn } from 'further-ui/components/Table';
import { CommitmentData } from '../../types';
import { numberToCurrencyString } from 'further-ui/utils';

type Props = Pick<CommitmentData, 'currencySettings' | 'incomeAndExpenses'>;

const IncomeAndExpenses: React.FC<Props> = ({
  currencySettings,
  incomeAndExpenses,
}) => {
  const { currencyLcy } = currencySettings;

  const columns: Array<TableColumn<(typeof incomeAndExpenses)[number]>> = [
    {
      label: 'Action',
      key: 'action',
      width: 220,
      render: ({ action }) => action,
    },
    {
      label: 'Date',
      key: 'date',
      width: 140,
      render: ({ date }) => date.toReadable(),
    },
    {
      label: 'Category',
      key: 'category',
      width: 200,
      render: ({ category }) => category,
    },
    {
      label: 'Income/(Expense)',
      key: 'valueLcy',
      width: 170,
      render: ({ valueLcy }) =>
        numberToCurrencyString(valueLcy, {
          currency: currencyLcy,
        }),
    },
  ];

  return (
    <Table
      emptyMessage="No entries"
      scrollable
      columns={columns}
      rows={incomeAndExpenses}
    />
  );
};

export default IncomeAndExpenses;
